

import React from 'react';

const tooltipContent = "We've detected potential issues with your selected document.\nIf you believe this is an error, you can still proceed with submitting your claim.";

export class ShowPBValidationMesssage extends React.Component {
  render() {
    const {
      document,
      attachDocuments,
      hasPendingDocAnywhere,
      onRunValidation,
      isReadOnly,
      data,
      onCancelValidation,
    } = this.props;
    const hasRunValidation = document.Success === true || document.Success === false;
    const hasPendingDoc = document.Success === null;
    const documentSuccess = document.Success;
    const documentMessage = document.Message;
    return (
      <div>
        {hasPendingDoc ? (
          <div>
            <div
              style={{
                backgroundColor: '#FFF9C4',
                padding: '10px',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                color: '#bfa100'
              }}
            >
              <span
                style={{
                  color: '#bfa100',
                  marginRight: '8px',
                  fontSize: '16px',
                }}
              >
                ⌛
              </span>
              <span>Validating...</span>

            </div>
            <button
              className="btn btn-sm btn-primary mt-2"
              onClick={() => onCancelValidation(document.claimRequiredDocumentId, data.claimTypeId)}
              disabled={isReadOnly}
            >
              Cancel Validation
            </button>
          </div>
        ) : documentSuccess === true ? (
          <div
            style={{
              backgroundColor: '#DDFFDD',
              padding: '10px',
              borderRadius: '6px',
              position: 'relative',
              color: '#2e7d32',
            }}
          >
            <div>
              <span
                style={{
                  color: '#4CAF50',
                  marginRight: '8px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
              >
                ✓
              </span>
              <span>
                {documentMessage || 'Document accepted.'}
              </span>
            </div>
          </div>
        ) : documentSuccess === false && documentMessage ? (
          <div
            style={{
              backgroundColor: '#FFDDDD',
              padding: '10px',
              borderRadius: '6px',
              color: '#c62828',
              position: 'relative',
              paddingRight: '30px',
              marginBottom: '8px',
            }}
          >
            <span
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: '#1976d2',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              title={tooltipContent.replace('\n', '\r\n')}
              data-toggle="tooltip"
              data-html="true"
              data-placement="top"
            >
              i
            </span>

            {documentMessage.split(/<br\s*\/?>/gi).map((line, lineIndex) => (
              line.trim() && (
                <div key={`line-${lineIndex}`}>
                  <span
                    style={{
                      color: '#F44336',
                      marginRight: '8px',
                      fontSize: '18px',
                      fontWeight: 'bold',
                    }}
                  >
                    ✕
                  </span>
                  <span>
                    {line.trim()}
                  </span>
                </div>
              )
            ))}
          </div>
        ) : (() => {
          // Check if this specific document has any attachments uploaded
          const hasAttachmentForThisDocument = attachDocuments.some(
            attachment => attachment.requiredDocumentId === document.claimRequiredDocumentId
          );

          // Only show "Document accepted" if document has attachment and runDocumentValidation is false
          return document.runDocumentValidation === false && hasAttachmentForThisDocument ? (
            <div
              style={{
                backgroundColor: '#DDFFDD',
                padding: '10px',
                borderRadius: '6px',
                position: 'relative',
                color: '#2e7d32',
              }}
            >
              <div>
                <span
                  style={{
                    color: '#4CAF50',
                    marginRight: '8px',
                    fontSize: '18px',
                    fontWeight: 'bold',
                  }}
                >
                  ✓
                </span>
                <span>Document accepted.</span>
              </div>
            </div>
          ) : null;
        })()}

        {(() => {
          // Check if this specific document has any attachments uploaded
          const hasAttachmentForThisDocument = attachDocuments.some(
            attachment => attachment.requiredDocumentId === document.claimRequiredDocumentId
          );

          if (!hasPendingDocAnywhere && document.runDocumentValidation !== false && hasAttachmentForThisDocument) {
            return (
              <div className="row align-items-center justify-content-center">
                <div className="col-auto">
                  <button
                    className="btn btn-sm btn-primary mt-2"
                    onClick={() => onRunValidation([], document.claimRequiredDocumentId, data.claimTypeId)}
                    disabled={isReadOnly}
                  >
                    {hasRunValidation ? 'Check Again' : 'Run Validation'}
                  </button>
                </div>
              </div>
            );
          }
          return null;
        })()}
      </div>
    );
  }
}

export default ShowPBValidationMesssage;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/components/ShowPBValidationMesssage/index.js